
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-admissions-week/[slug]",
      function () {
        return require("private-next-pages/virtual-admissions-week/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-admissions-week/[slug]"])
      });
    }
  